export default __webpack_public_path__ + "static/media/20-LAX.7667970c.jpg";